import { getPriorityTagAppearance } from 'helpers/priorityColor.helper/priorityColor.helper'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const SIZE_CLASS = {
  medium: 'px-3 py-1 text-sm',
  small: 'px-2 py-0.5 text-xs',
}

type PriorityTagProps = {
  priority: SystemSettingPriorityLevel
  disabled?: boolean
  /** `small` for table cells. Either size shrinks to its container and cuts its name off with "…". */
  size?: keyof typeof SIZE_CLASS
  onClick?: () => void
}

export default function PriorityTag({
  priority,
  disabled = false,
  size = 'medium',
  onClick,
}: PriorityTagProps): ReactNode {
  const { t } = useTranslation()
  const name = t(priority.display_name)
  const { className: colorClassName, style } = getPriorityTagAppearance(priority.priority_level, priority.display_color)
  const className = `inline-flex max-w-full items-center rounded-full font-medium transition-opacity ${SIZE_CLASS[size]} ${colorClassName} ${disabled ? 'opacity-50' : ''} ${onClick ? 'cursor-pointer' : ''}`
  const label = <span className="truncate">{name}</span>

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-pressed={!disabled}
        aria-label={name}
        className={className}
        style={style}
      >
        {label}
      </button>
    )
  }

  return (
    <span className={className} style={style} title={name}>
      {label}
    </span>
  )
}
